<template>
	<div class="bg-accented w-full">
		<UCollapsible>
			<UButton
				:label="faq.question"
				variant="ghost"
				color="neutral"
				class="w-full flex justify-between font-semibold bg-accented first-of-type:my-2 text-lg text-left text-highlighted"
				trailing-icon="i-lucide-chevron-down"
				size="xl"
				:ui="{
					base: 'rounded-lg',
					label: 'text-wrap'
				}"
			/>
			<template #content>
				<div class="text-muted mx-4 pb-4">
					<p v-html="faq.answer" />
				</div>
			</template>
		</UCollapsible>
	</div>
</template>

<script setup lang="ts">
import type { FaqProps } from '@/types/components/faqs'

defineProps({
	faq: {
		type: Object as PropType<FaqProps>,
		required: true
	}
})
</script>
